import moment from 'moment-timezone';

export const getDefaultTimeInterval = ([rangeStart, rangeEnd]: [string, string]): [
  string,
  string,
] => {
  const start = moment(rangeStart).startOf('seconds');
  const end = moment(rangeEnd).startOf('seconds');
  const yesterdayStart = moment().subtract(1, 'day').startOf('day');
  const yesterdayEnd = yesterdayStart.clone().endOf('day').startOf('seconds');

  if (start.isSameOrBefore(yesterdayStart) && end.isSameOrAfter(yesterdayEnd)) {
    return [yesterdayStart.toISOString(), yesterdayEnd.toISOString()];
  }

  const isLastSecond = end.isSame(end.clone().endOf('hours').startOf('seconds'));
  const startResult = end
    .clone()
    .subtract(24, 'hours')
    .add(isLastSecond ? 1 : 0, 'seconds');

  if (startResult.isBefore(start)) {
    return [start.toISOString(), end.toISOString()];
  }

  return [startResult.toISOString(), end.toISOString()];
};

export const checkTimeIntervalAvailable = (
  interval: [string, string],
  availableRange: [string, string],
) => {
  const [intervalStart, intervalEnd] = interval.map((t) => moment(t).startOf('seconds'));
  const [availableStart, availableEnd] = availableRange.map((t) => moment(t).startOf('seconds'));

  if (intervalStart.isSameOrAfter(availableStart) && intervalEnd.isSameOrBefore(availableEnd)) {
    return 'available';
  }

  if (intervalStart.isAfter(availableEnd) || intervalEnd.isBefore(availableStart)) {
    return 'outOfRange';
  }

  return 'overlap';
};
